import React, { useEffect, useState } from "react";
import { Text, View } from "react-native";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppColors } from "../../../utility/AppColors";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { GameShow } from "../../../utility/types/gameShowTypes";
import withErrorBoundary from "../../../utility/auth/withErrorBoundary";

type TimerComponentProps = {
  isMinAttendees?: boolean;
  isMoreTimeLeft?: boolean;
  timeLeft?: any;
  requiredNumber?: number;
  totalPercentage?: number;
  eventType?: string;
  pastEvent?: boolean;
  eventData?: any;
  showTimer?: boolean;
  formattedDate?: string;
  title?: string;
  EventDetail?: string;
  IsEventCanceled: any;
  screen?: any;
  IsEventCompleted?: any;
};

const TimerComponent: React.FC<TimerComponentProps> = ({
  isMinAttendees = false,
  isMoreTimeLeft = false,
  timeLeft,
  requiredNumber,
  totalPercentage,
  eventType,
  pastEvent = false,
  eventData,
  showTimer = true,
  formattedDate,
  title = "",
  EventDetail = "",
  IsEventCanceled = false,
  screen = "",
  IsEventCompleted,
}) => {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [totalStreamTime, setTotalStreamTime] = useState("");
  useEffect(() => {
    if (eventData?.event?.eventStartTime && eventData?.event?.eventEndTime) {
      const startTime = new Date(eventData.event.eventStartTime).getTime();
      const endTime = new Date(eventData.event.eventEndTime).getTime();

      const differenceMs = endTime - startTime;

      const hours = Math.floor(differenceMs / (1000 * 60 * 60));
      const minutes = Math.floor(
        (differenceMs % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((differenceMs % (1000 * 60)) / 1000);

      const timeString = `${hours > 0 ? `${hours}h ` : ""}${minutes}m ${seconds > 0 ? `${seconds}s` : ""
        }`;
      setTotalStreamTime(timeString);
    }
  }, [eventData]);

  return (
    <>
      <Text
        numberOfLines={1}
        ellipsizeMode="tail"
        style={[
          deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
            ? AppFontStyle.BOLD_ANYBODY_24
            : AppFontStyle.BOLD_ANYBODY_18,
          {
            maxWidth: "100%",
            width: "100%",
            textAlign: (deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM) && !pastEvent ? "center" : undefined,
          },
        ]}
      >
        {title}
      </Text>
      {/* {EventDetail === "EventDetail" && !isMoreTimeLeft ? ( */}
      {!pastEvent && (
        <Text
          style={[
            deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
              ? AppFontStyle.BOLD_ANYBODY_17
              : AppFontStyle.BOLD_ANYBODY_12,
            {
              color: IsEventCompleted
                ? AppColors.red_FA0A0A
                : IsEventCanceled
                  ? AppColors.red_FA0A0A
                  : AppColors.green_52FF6F,
              // Position relative on mobile for proper layout
              marginTop: (deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM) ? 8 : 0,
            },
          ]}
        >
          {IsEventCompleted
            ? "Ended"
            : IsEventCanceled
              ? "Event is Cancelled"
              : "Event will start in:"}
        </Text>
      )}

      {/* ) : null} */}

      {/* For pastEvent: Show Stream time with Hours/Minutes/Seconds only */}
      {pastEvent ? (
        <View style={{ marginTop: 8 }}>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_12,
              { color: "#9CA3AF", marginBottom: 10 },
            ]}
          >
            Stream time
          </Text>
          <View
            style={[
              styles.timeContainer,
              { marginBottom: (deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM) ? 15 : 27, justifyContent: "flex-start", gap: 12 },
            ]}
          >
            {/* Hours */}
            <View style={{ alignItems: "center" }}>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_24,
                  {
                    backgroundColor: "rgba(220, 38, 38, 0.40)",
                    padding: 10,
                    borderRadius: 12,
                    color: AppColors.red_FA0A0A,
                    minWidth: 50,
                    textAlign: "center",
                  },
                ]}
              >
                {String(timeLeft?.hours || 0).padStart(2, "0")}
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_12,
                  { color: AppColors.gray_C3C3C3, marginTop: 2 },
                ]}
              >
                Hours
              </Text>
            </View>
            {/* Minutes */}
            <View style={{ alignItems: "center" }}>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_24,
                  {
                    backgroundColor: "rgba(220, 38, 38, 0.40)",
                    padding: 10,
                    borderRadius: 12,
                    color: AppColors.red_FA0A0A,
                    minWidth: 50,
                    textAlign: "center",
                  },
                ]}
              >
                {String(timeLeft?.minutes || 0).padStart(2, "0")}
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_12,
                  { color: AppColors.gray_C3C3C3, marginTop: 2 },
                ]}
              >
                Minutes
              </Text>
            </View>
            {/* Seconds */}
            <View style={{ alignItems: "center" }}>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_24,
                  {
                    backgroundColor: "rgba(220, 38, 38, 0.40)",
                    padding: 10,
                    borderRadius: 12,
                    color: AppColors.red_FA0A0A,
                    minWidth: 50,
                    textAlign: "center",
                  },
                ]}
              >
                {String(timeLeft?.seconds || 0).padStart(2, "0")}
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_12,
                  { color: AppColors.gray_C3C3C3, marginTop: 2 },
                ]}
              >
                Second
              </Text>
            </View>
            {/* Ended label on the right */}
            <Text
              style={[
                deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                  ? AppFontStyle.BOLD_ANYBODY_17
                  : AppFontStyle.BOLD_ANYBODY_12,
                {
                  color: AppColors.red_FA0A0A,
                  marginLeft: "auto",
                  alignSelf: "center",
                },
              ]}
            >
              Ended
            </Text>
          </View>
        </View>
      ) : (
        /* Regular countdown for non-past events */
        <View
          style={[
            styles.timeContainer,
            { marginBottom: IsEventCanceled ? 0 : (deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM) ? 5 : 27 },
          ]}
        >
          <View
            style={{
              alignItems: "center",
              marginTop: 10,
            }}
          >
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_24,
                {
                  backgroundColor: "rgba(220, 38, 38, 0.40)",
                  padding: 10,
                  borderRadius: 12,
                  color: AppColors.red_FA0A0A,
                },
              ]}
            >
              {IsEventCanceled
                ? "00"
                : IsEventCompleted
                  ? `${timeLeft?.days < 10 ? "0" : ""}${timeLeft?.days || 0}`
                  : `${timeLeft.days < 10 ? "0" : ""}${timeLeft.days}`}
            </Text>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_12,
                { color: AppColors.gray_C3C3C3, marginTop: 2 },
              ]}
            >
              Days
            </Text>
          </View>
          <View
            style={{
              alignItems: "center",
              marginTop: 10,
            }}
          >
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_24,
                {
                  backgroundColor: "rgba(220, 38, 38, 0.40)",
                  padding: 10,
                  borderRadius: 12,
                  color: AppColors.red_FA0A0A,
                },
              ]}
            >
              {IsEventCanceled
                ? "00"
                : IsEventCompleted
                  ? `${timeLeft?.hours < 10 ? "0" : ""}${timeLeft?.hours || 0}`
                  : `${timeLeft.hours < 10 ? "0" : ""}${timeLeft.hours}`}
            </Text>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_12,
                { color: AppColors.gray_C3C3C3, marginTop: 2 },
              ]}
            >
              Hours
            </Text>
          </View>
          <View
            style={{
              alignItems: "center",
              marginTop: 10,
            }}
          >
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_24,
                {
                  backgroundColor: "rgba(220, 38, 38, 0.40)",
                  padding: 10,
                  borderRadius: 12,
                  color: AppColors.red_FA0A0A,
                },
              ]}
            >
              {IsEventCanceled
                ? "00"
                : IsEventCompleted
                  ? `${timeLeft?.minutes < 10 ? "0" : ""}${timeLeft?.minutes || 0}`
                  : `${timeLeft.minutes < 10 ? "0" : ""}${timeLeft.minutes}`}
            </Text>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_12,
                { color: AppColors.gray_C3C3C3, marginTop: 2 },
              ]}
            >
              Minutes
            </Text>
          </View>
          <View
            style={{
              alignItems: "center",
              marginTop: 10,
            }}
          >
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_24,
                {
                  backgroundColor: "rgba(220, 38, 38, 0.40)",
                  color: AppColors.red_FA0A0A,
                  padding: 10,
                  borderRadius: 12,
                },
              ]}
            >
              {IsEventCanceled
                ? "00"
                : IsEventCompleted
                  ? `${timeLeft?.seconds < 10 ? "0" : ""}${timeLeft?.seconds || 0}`
                  : `${timeLeft.seconds < 10 ? "0" : ""}${timeLeft.seconds}`}
            </Text>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_12,
                { color: AppColors.gray_C3C3C3, marginTop: 2 },
              ]}
            >
              Seconds
            </Text>
          </View>
        </View>
      )}
      {showTimer === true ? (
        <>
          {!pastEvent && (
            <>
              {eventType === "Public" ? null : (
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    {
                      color: AppColors.gray_C3C3C3,
                      marginTop: 2,
                      textAlign: "right",
                    },
                  ]}
                >
                  {totalPercentage > 100
                    ? "100%"
                    : `${Math.round(totalPercentage)}  %`}
                </Text>
              )}

              <View
                style={{
                  paddingVertical: 5,
                  flexDirection: "row",
                }}
              >
                <View
                  style={{
                    height: 10,
                    width: "100%",
                    backgroundColor: AppColors.grayColor_D9D9D9,
                    borderRadius: 100,
                    overflow: "hidden",
                  }}
                >
                  <View
                    style={{
                      height: "100%",
                      width:
                        eventType === "Public" ? "100%" : `${totalPercentage}%`,
                      backgroundColor: AppColors.appViolentColor_6D08C3,
                    }}
                  />
                </View>
              </View>
            </>
          )}
          {pastEvent ? (
            <View
              style={{
                flexDirection: "row",
                columnGap: 10,
                alignSelf: "center",
                marginVertical: 10,
                justifyContent: "center",
                width: "100%",
                alignItems: "center",
              }}
            >
              <Text style={AppFontStyle.BOLD_ANYBODY_12}>{formattedDate}</Text>

              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_12,
                  { color: AppColors.red_FF0740 },
                ]}
              >
                Ended
              </Text>
            </View>
          ) : (
            <View
              style={{
                flexDirection: "row",
                columnGap: 40,
                alignSelf: "center",
                marginVertical: 10,
                justifyContent:
                  eventType === "Public" ? "center" : "space-between",
                width: "100%",
              }}
            >
              {eventType === "Public" ? (
                <Text style={AppFontStyle.REGULAR_ANYBODY_14}>
                  Get Ready for the Challenge!
                </Text>
              ) : (
                <>
                  <Text style={AppFontStyle.REGULAR_ANYBODY_14}>
                    Almost there
                  </Text>
                  {requiredNumber < 0 ? (
                    <Text style={AppFontStyle.REGULAR_ANYBODY_14}>
                      minimum attendees criteria fulfilled
                    </Text>
                  ) : (
                    <Text style={AppFontStyle.REGULAR_ANYBODY_14}>
                      {requiredNumber} more required for event to go ahead
                    </Text>
                  )}
                </>
              )}
            </View>
          )}
        </>
      ) : (
        !IsEventCanceled && (
          <Text
            style={
              deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                ? AppFontStyle.BOLD_ANYBODY_24
                : AppFontStyle.BOLD_ANYBODY_18
            }
          >
            {formattedDate}
          </Text>
        )
      )}
    </>
  );
};

export default withErrorBoundary(TimerComponent);

const useStyles = CreateResponsiveStyle(
  {
    timeContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {
      timeContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        gap: 8,
      },
    },
    [DEVICE_SIZES.XS]: {
      timeContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        gap: 8,
      },
    },
  }
);
